import React, { FC } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import LaunchIcon from '@mui/icons-material/Launch';
// import sx from '@mui/system/sx';
import ExternalLink from '../../components/ExternalLink/ExternalLink';
import { deepLink } from '../../utils/constants';

export interface Case {
  title: string;
  date: string;
  status: string;
  avatar?: string;
  secondDate: string;
  sForceId: string;
}

type Props = {
  cases: Case[];
};

const CasesList: FC<Props> = ({ cases }) => {
  if (!cases?.length)
    return (
      <Box
        alignItems="center"
        gap={1.75}
        display="flex"
        flexDirection="column"
        mb={5}
        px={4}
        border="1px solid #ddd"
        padding={4}
        sx={{ marginTop: '9.6px' }}
      >
        <Box alignItems="center" gap={1.25} display="flex" flexDirection="column">
          <Typography fontSize={16} fontWeight={500} lineHeight="120%" color="black">
            Currently, there are no cases.
          </Typography>
          <Typography fontSize={14} fontWeight={500} lineHeight="130%" color="#A2A2A2" px={2} textAlign="center">
            The cases will appear here.
          </Typography>
        </Box>
      </Box>
    );

  return (
    <List sx={{ width: '100%', mt: 1 }} dense disablePadding>
      {cases.map(({ title, date, status, avatar, secondDate, sForceId }) => (
        <ListItem
          sx={{
            px: 0,
            alignItems: 'flex-start',
            borderBottom: '1px dashed #E3E3E3',
            marginBottom: '10px',
            paddingBottom: '15px',
            '&:last-child': { borderBottom: 0, paddingBottom: 0 },
          }}
          key={title}
        >
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <ListItemAvatar sx={{ py: 0.6, minWidth: 'auto' }}>
              <Avatar
                sx={{
                  background: '#e3e3e3',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  marginRight: '15px',
                }}
              >
                <Icon icon="carbon:document-blank" color="#000" fontSize={14} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography fontSize={16} color="#3E3E3E" fontWeight={500}>
                  {title}
                </Typography>
              }
              secondary={
                <Box>
                  <Typography fontSize={14} color="#3E3E3E" fontWeight={400}>
                    {date}
                  </Typography>
                  <Typography fontSize={14} color="#3E3E3E" fontWeight={400}>
                    {secondDate}
                  </Typography>
                  <Typography
                    fontSize={12}
                    color="#3E3E3E"
                    fontWeight={400}
                    sx={{
                      display: 'inline-block',
                      borderRadius: '2px',
                      border: '1px solid #717171',
                      padding: '0 8px',
                      marginTop: '2px',
                    }}
                  >
                    {status}
                  </Typography>
                </Box>
              }
              primaryTypographyProps={{ sx: { fontSize: 14, fontWeight: 500, color: '#456BD9', mb: 0.4 } }}
              secondaryTypographyProps={{ sx: { fontSize: 12, fontWeight: 400, color: '#3E3E3E' } }}
            />
            <ExternalLink
              style={{ fontSize: '16px' }}
              href={`${process.env.REACT_APP_CASE}${sForceId}`}
              target="_blank"
              rel="noreferrer"
            >
              <LaunchIcon color="primary" fontSize="inherit" sx={{ marginTop: '10px' }} />
            </ExternalLink>
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export default CasesList;
